import React, { useEffect, useState } from 'react';
import { Modal, Box, Grid, Typography, Autocomplete, TextField, Button, MenuItem, Fade, FormControl, InputLabel, Select, OutlinedInput, Checkbox, ListItemText, GlobalStyles } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TimePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import moment from 'moment';
import { Link, useNavigate } from "react-router-dom";
import AddChecklistHierarchy from './AddChecklistHierarchy';
import ApiService from '../../../functions/apiService';
import ButtonDatePicker from '../../../components/DatePickers/ButtonDatePicker';
import Multiselect from 'multiselect-react-dropdown';

const ChecklistModal = ({ open, onClose, onSubmit, id, locationItem = [] }) => {
	const [checklist, setChecklist] = useState('');
	const [title, setTitle] = useState('');
	const [item, setItem] = useState({});
	const [duration, setDuration] = useState([]);
	const [date, setDate] = useState(new Date());
	const [day, setDay] = useState('');
	const [selectedDate, setSelectedDate] = useState(null);
	const [time, setTime] = useState(null);
	const [positionDrop, setPositionDrop] = useState([]);
	const [itemsList, setItemsList] = useState([]);
	const [loading, setLoading] = useState(false);
	const [nestedData, setNestedData] = useState([]);
	let navigate = useNavigate();
	const [targets, setTargets] = useState([])
	const [ticketAssignTo, setTicketAssignTo] = useState("");
	const [ticketNotifyTo, setTicketNotifyTo] = useState([]);
	const [position, setPosition] = useState(null);
	const [assignedTo, setAssignedTo] = useState(null);
	const [employees, setEmployees] = useState([])
	const [checklistUpdateTo, setChecklistUpdateTo] = useState("");

	const durationOptions = [
		{ label: "Daily", value: "daily" },
		{ label: "Every Other Day", value: "everyotherday" },
		{ label: "Weekly", value: "weekly" },
		{ label: "Bi-weekly", value: "biweekly" },
		{ label: "Monthly", value: "monthly" }
	]

	const dayOptions = [
		{ label: "Monday", value: "Monday" },
		{ label: "Tuesday", value: "Tuesday" },
		{ label: "Wednesday", value: "Wednesday" },
		{ label: "Thursday", value: "Thursday" },
		{ label: "Friday", value: "Friday" },
		{ label: "Saturday", value: "Saturday" },
		{ label: "Sunday", value: "Sunday" }
	]

	const mapLocationItems = (locationItems) => {
		return locationItems.map((item) => ({
			description: '',
			item_id: item.id,
			item_label: item.item_description,
			checked: false,
		}));
	};

	useEffect(() => {
		if (!open) {
			setChecklist('');
			setTitle('');
			setItem({});
			setDuration([]);
			setDay('');
			setSelectedDate(null);
			setTime(null);
			if (locationItem.length > 0) {
				setItemsList(mapLocationItems(locationItem));
			}
		}
	}, [open]);

	useEffect(() => {
		if (locationItem.length > 0) {
			setItemsList(mapLocationItems(locationItem));
		}
	}, [locationItem]);

	useEffect(() => {
		getPositionDropown()
		loadEmployees()
	}, [])

	const getPositionDropown = () => {
		setLoading(true);
		ApiService.get('/positions-list')
			.then(({ data }) => {
				var certArr = data?.data.map((cer) => { return { label: cer.SO_Desc, value: cer.SO_Value } })
				setPositionDrop(certArr)
				setLoading(false);
			})
			.catch((e) => {
				setLoading(false);
			})
	}

	const loadEmployees = () => {
		setLoading(true);
		ApiService.get('/employee-list-inventory')
			.then(({ data }) => {
				var tempArr = []
				data.data.map((emp) => {
					var obj = {
						label: `${emp.employee_assignment.EA_Rank} ${emp.fullName}`,
						value: emp.Emp_Code
					}
					tempArr.push(obj)
				})
				setEmployees(tempArr)
				setLoading(false);
			})
			.catch((e) => {
				setLoading(false);
			})
	}

	const handleCreate = () => {
		const formatItems = itemsList.filter(item => item.checked).map((item) => ({
			description: item.description,
			item_id: item.item_id
		}))
		var tempDay = (duration == 'monthly' || duration == 'everyotherday') ? moment(date).format('YYYY-MM-DD') : day
		const newChecklist = {
			title,
			parent_location_id: id?.id,
			duration,
			assignedTo: assignedTo?.value,
			position: position?.value,
			items: formatItems,
			time: moment(time).format('HH:mm:ss'),
			day: tempDay,
			ticket_assigned_to: ticketAssignTo?.value,
			"notify_employees": ticketNotifyTo.map((a) => { return a?.value }),
			notify_checklist_update_to: checklistUpdateTo?.value,
			targets: targets
		};

		if (onSubmit) {
			onSubmit(newChecklist);
		}
	};

	const getItem = () => {
		const body = {
			"location_id": location
		}
		setLoading(true);
		ApiService.post('/checklist/hirearchy_data', body)
			.then((data) => {
				var load = data?.data.my_items.map((ldd) => { return { label: ldd.item_description, value: ldd.id } })
				setItemDrop(load)
				setLoading(false);
			})
			.catch((e) => {
				setLoading(false)
			})
	}

	useEffect(() => {
		getItem()
	}, [id])

	const markAllSelected = (node) => {
		node.selected = true;

		if (node.locations && node.locations.length > 0) {
			node.locations = node.locations.map(markAllSelected);
		}

		if (node.items && node.items.length > 0) {
			node.items = node.items.map(item => ({ ...item, selected: true }));
		}

		return node;
	};

	let loadData = () => {
		const body = {
			"id": id,
		}
		ApiService.post('/checklist/hirearchy_data', body)
			.then((data) => {
				const updatedData = markAllSelected(data?.data);
				setNestedData(updatedData);
			}).catch((e) => {
				console.error("error")
			})
	}

	useEffect(() => {
		loadData();
	}, [id]);

	const buildSubTree = (node) => {
		if (!node.selected) return null;

		const result = {
			description: node.desc || '',
			location_id: node.id,
			parent_location_id: node.location_parent_id,
			type: node.type || (node.item ? 'item' : 'location'),
		};

		const items = node.items?.filter(i => i.selected).map(item => ({
			description: item.desc || '',
			item_id: item.item_id,
			parent_location_id: item.location_id,
			type: 'item'
		}));

		const subLocations = node.locations?.map(buildSubTree).filter(Boolean);

		if (items?.length) result["items"] = items;
		if (subLocations?.length) result["sub-location"] = subLocations;

		return result;
	};
	
	const buildTargets = (rootNode) => {
		if (!rootNode?.selected) return [];

		const targets = [];

		rootNode.locations?.forEach(child => {
			const target = buildSubTree(child);
			if (target) targets.push(target);
		});

		rootNode.items?.forEach(item => {
			if (item.selected) {
				targets.push({
					description: item.desc || '',
					item_id: item.item_id,
					parent_location_id: item.location_id,
					type: 'item'
				});
			}
		});

		return targets;
	};

	const handleSubmit = () => {
		const targets = buildTargets(nestedData);
		setTargets(targets);
	};

	useEffect(() => {
		const updatedTargets = buildTargets(nestedData);
		setTargets(updatedTargets);
	}, [nestedData]);


	return (
		<>
			<GlobalStyles
				styles={{
					'.checklist-modal-box': {
						outline: 'none !important',
					},
				}}
			/>
			<Modal
				open={open}
				onClose={onClose}
				closeAfterTransition
				BackdropProps={{
					timeout: 300,
				}}
			>
				<Fade in={open}>
					<Box
						className="checklist-modal-box"
						sx={{
							position: 'absolute',
							top: '50%',
							left: '50%',
							transform: 'translate(-50%, -50%)',
							width: 800,
							bgcolor: 'background.paper',
							borderRadius: '10px',
							boxShadow: 24,
						}}
					>
						<div style={{ borderBottom: '1px solid #666666', marginBottom: '20px' }}>
							<Box sx={{ py: 1, px: 3 }}>
								<Grid container spacing={3} style={{ alignItems: 'center', justifyContent: 'space-between' }}>

									{/* Title */}
									<Grid item xs={10}>
										<div
											style={{
												// backgroundColor: '#FBFBFB',
												border: '1px solid #dddddd',
												borderRadius: '5px',
											}}
											className='mt-2 mb-2'
										>
											<input
												type='text'
												value={title}
												onChange={(e) => setTitle(e.target.value)}
												placeholder={"Enter Checklist Title"}
												style={{ fontSize: '16px', padding: '8px 10px', width: "100%", outline: "none", backgroundColor: 'transparent', border: '0' }} />
											<style>
												{`
                        input::placeholder {
                          color: gray ;
                        }
                      `}
											</style>
										</div>
									</Grid>

									{/* Close Button */}
									<Grid item xs={2} style={{ display: 'flex', justifyContent: 'end' }}>
										<img
											src="/images/close-icon.svg"
											onClick={onClose}
											style={{ cursor: 'pointer' }}
											width={24}
											height={24}
										/>
									</Grid>
								</Grid>
							</Box>
						</div>

						<div>
							<Box sx={{ py: 3, px: 3, mt: 1 }}>
								<Grid container spacing={2}>
									{/* Hierarchy Box */}
									<Grid item xs={12} sm={6} md={12} sx={{ marginBottom: '20px' }}>
										<div style={{maxHeight:220,minHeight:180, overflow:'scroll', paddingRight:20}}>
											{!id &&
												<Box className='hierarchy-box' >
													<img src='/images/empty.png' style={{ height: 200, width: 250 }}>
													</img>
												</Box>
											}

											{nestedData &&
												<Box>
													<AddChecklistHierarchy
														key={nestedData.id}
														propdata={nestedData}
														loadData={loadData}
														location={id}
														parentSelected={nestedData.selected}
														handleSubmit={handleSubmit}
														setNestedData={setNestedData}
													/>
												</Box>
											}
										</div>
									</Grid>

									{/* Duration */}
									<Grid item xs={4}>
										<Autocomplete
											options={durationOptions}
											getOptionLabel={(option) => option.label}
											value={duration ? durationOptions.find(opt => opt.value === duration) || null : null}
											onChange={(_, newValue) => setDuration(newValue ? newValue.value : "")}
											renderInput={(params) => (
												<TextField
													{...params}
													variant="outlined"
													size="small"
													placeholder="Select Duration"
													sx={{
														"& .MuiInputBase-root": {
															height: "50px",
															fontSize: "14px"
														}
													}}
												/>
											)}
										/>
									</Grid>

									{/* Postions */}
									<Grid item xs={4}>
										<Autocomplete
											options={positionDrop}
											disabled={assignedTo !== null}
											onChange={(event, newValue) => setPosition(newValue)}
											value={position}
											sx={{
												"& .MuiInputBase-root": {
													height: "50px",
													fontSize: "14px",
													display: "flex",
													alignItems: "center"
												}
											}}
											renderInput={(params) => (
												<TextField
													{...params}
													placeholder="Assign by Position"
												/>
											)}
										/>
									</Grid>

									{/* Assigned To */}
									<Grid item xs={4}>
										<Autocomplete
											options={employees}
											disabled={position != null ? true : false}
											value={assignedTo}
											onChange={(event, newValue) => { setAssignedTo(newValue) }}
											sx={{
												"& .MuiInputBase-root": {
													height: "50px",
													fontSize: "14px",
													display: "flex",
													alignItems: "center"
												}
											}}
											renderInput={(params) => (
												<TextField
													{...params}
													placeholder="Assign by Employee"
												/>
											)}
										/>
									</Grid>

									{/* Days Dropdown */}
									{((duration == "weekly") || (duration == "biweekly")) &&
										<Grid item xs={4} className='mt-2'>
											<Autocomplete
												options={dayOptions}
												getOptionLabel={(option) => option.label}
												value={day ? dayOptions.find(opt => opt.value === day) || null : null}
												onChange={(_, newValue) => setDay(newValue ? newValue.value : "")}
												renderInput={(params) => (
													<TextField
														{...params}
														variant="outlined"
														size="small"
														placeholder="Select Day"
														sx={{
															"& .MuiInputBase-root": {
																height: "50px",
																fontSize: "14px"
															}
														}}
													/>
												)}
											/>
										</Grid>}

									{/* Calender */}
									{(duration == "monthly" || duration == 'everyotherday') &&
										<Grid item xs={4} className='d-grid'>
											<LocalizationProvider dateAdapter={AdapterDateFns}>
												<ButtonDatePicker
													className='w-100'
													label={moment(date).format('YYYY-MM-DD')}
													value={date}
													onChange={(e) => setDate(e)}
													minDate={new Date()}
													sx={{
														width: "100%",
														"& .MuiButtonBase-root": {
															height: '50px',
															fontSize: '14px'
														},
														width: "100%",
														"& .MuiButton-root": {
															height: '50px',
															fontSize: '14px'
														},
														width: "100%",
														"& .MuiInputBase-root": {
															height: '50px',
															fontSize: '14px'
														},
													}}
												/>
											</LocalizationProvider>
										</Grid>
									}

									{/* Time */}
									<Grid item xs={4}>
										<LocalizationProvider dateAdapter={AdapterDateFns}>
											<TimePicker
												placeholder='Add Time'
												// timeSteps={{ minutes: 1 }}
												value={time}
												onChange={(newValue) => setTime(newValue)}
												className='mt-0'
												sx={{
													width: "100%",
													"& .MuiInputBase-root": {
														height: '50px',
														fontSize: '14px'
													},
												}}
											/>
										</LocalizationProvider>
									</Grid>

									{/* Ticket Assign to */}
									<Grid item xs={12} sm={6} md={4}>
										<Autocomplete
											options={employees}
											value={ticketAssignTo}
											onChange={(event, newValue) => { setTicketAssignTo(newValue) }}
											sx={{
												"& .MuiInputBase-root": {
													height: "50px",
													fontSize: "14px",
													display: "flex",
													alignItems: "center"
												}
											}}
											renderInput={(params) => (
												<TextField
													{...params}
													placeholder="Assign Ticket to"
												/>
											)}
										/>
									</Grid>

									{/* Ticket Notify to */}
									<Grid item xs={12} sm={6} md={4}>
										<Multiselect
											displayValue="label"
											options={employees}
											showCheckbox
											showArrow
											customCloseIcon={<><img src='/images/cross.png' /></>}
											placeholder='Notify Ticket to'
											selectedValues={ticketNotifyTo}
											onSelect={(e) => setTicketNotifyTo(e)}
											onRemove={(e) => setTicketNotifyTo(e)}
										/>
									</Grid>

									{/* Notify Checklist Update to */}
									<Grid item xs={12} sm={6} md={4}>
										<Autocomplete
											options={employees}
											value={checklistUpdateTo}
											onChange={(event, newValue) => { setChecklistUpdateTo(newValue) }}
											sx={{
												"& .MuiInputBase-root": {
													height: "50px",
													fontSize: "14px",
													display: "flex",
													alignItems: "center"
												}
											}}
											renderInput={(params) => (
												<TextField
													{...params}
													placeholder="Notify Checklist Update to"
												/>
											)}
										/>
									</Grid>
								</Grid>
							</Box>
						</div>

						<div className="pt-2 pb-5 px-3" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
							<Button variant="contained" color="primary" onClick={handleCreate}
								disabled={title == '' || duration.length === 0 || (assignedTo == '' && position == '') || time == null}
							>
								Create Checklist
							</Button>
						</div>

					</Box>
				</Fade >
			</Modal >
		</>
	);
};

export default ChecklistModal;

{/* Item & Description */ }
{/* {itemsList.length === 0 ? (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  margin: '24px 0px',
                }}
              >
                <Grid item xs={12}>
                  <img
                    src="/images/empty-checklist.svg"
                    style={{ cursor: 'pointer' }}
                    alt="Empty Checklist"
                  />
                </Grid>
              </div>
            ) : (
              <div>
                <Box sx={{ px: 3, height: '28vh', overflow: 'scroll', mb: 1 }}>
                  <div>
                    {itemsList.map((item, index) => (
                      <div key={index} >
                        <Box sx={{ flexGrow: 1 }} style={{ marginBottom: '12px' }}>
                          <Grid container spacing={2} style={{ alignItems: 'center' }}>
                            <Grid item xs={7} className='pt-4'>
                              <div style={{ display: 'flex', justifyContent: 'start', alignItems: 'center', gap: '10px' }}>
                                <Checkbox
                                  checked={item.checked}
                                  onChange={() => handleToggleCheck(index)}
                                  disabled={item.description.trim() === '' && !item.checked}
                                  className='p-0'
                                />

                                ]
                                <input
                                  type="text"
                                  value={item.description}
                                  placeholder="Enter Description"
                                  onChange={(e) => handleEditDescription(index, e.target.value)}
                                  style={{
                                    width: '100%',
                                    padding: '6px 12px',
                                    fontSize: '12px',
                                    borderRadius: '5px',
                                    border: '1px solid #ddd',
                                    // backgroundColor: '#FBFBFB'
                                  }}
                                />
                              </div>
                            </Grid>

                            <Grid item xs={4} className='pt-4'>
                              <div style={{ display: 'flex', justifyContent: 'start', alignItems: 'center', gap: '10px' }}>
                                <img src="/images/location-blue.svg" />
                                <p variant="body1" className='mb-0 item-style' style={{ width: '100%', wordBreak: 'break-word', fontSize: '12px', color: '#BF1D2D', fontFamily: 'Karla' }}>{item.item_label}</p>
                              </div>
                            </Grid>

                            <Grid item xs={1}>
                              <img src="/images/close-icon.svg" width={18} height={18} style={{ cursor: 'pointer' }} onClick={() => handleRemoveItem(index)} />
                            </Grid>
                          </Grid>
                        </Box>
                      </div>
                    ))}
                  </div>
                </Box>
              </div>
            )} */}

{/* Add Description */ }
{/* <Grid item xs={7}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      size="small"
                      placeholder="Add Description"
                      value={checklist}
                      onChange={(e) => setChecklist(e.target.value)}
                      sx={{
                        "& .MuiInputBase-root": {
                          height: "40px",
                          fontSize: "14px",
                          display: "flex",
                          alignItems: "center"
                        }
                      }}
                    />
                  </Grid> */}

{/* <Grid item xs={4}>
                    <FormControl variant="standard" sx={{ width: '100%' }}>
                      <InputLabel id="demo-simple-select-standard-label" sx={{ pb: 1 }}>Select Item</InputLabel>
                      <Select
                        labelId="demo-simple-select-standard-label"
                        id="demo-simple-select-standard"
                        value={item}
                        onChange={(e) => setItem(e.target.value)}
                        label="Select Item"
                      // variant='outlined'
                      >
                        {locationItem.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item.item_description}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid> */}

{/* Select Item */ }
{/* <Grid item xs={4}>
                    <Autocomplete
                      options={dayOptions}
                      onChange={(event, newValue) => setItem(newValue)}
                      value={item}
                      sx={{
                        "& .MuiInputBase-root": {
                          height: "40px",
                          fontSize: "14px",
                          display: "flex",
                          alignItems: "center"
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder="Select Item"
                        />
                      )}
                    />
                  </Grid> */}

{/* Add Button */ }
{/* <Grid item xs={1}>
                    <div className="add-btn" onClick={handleAddItem} style={{ marginTop: '6px' }} >
                      <img src="/images/Plus-Blue.png" style={{ cursor: 'pointer', width: 25, height: 25 }} />
                    </div>
                  </Grid> */}